import { ADMIN_PATHS, NETWORK_PATHS, PATHS } from "@/routing/paths"

export const getCollaboratorLinkSheet = <TCollaborator extends { id: string }>(
  collaborator?: TCollaborator | null
) => {
  return `${PATHS.NETWORK}${NETWORK_PATHS.COLLABORATORS}/${collaborator?.id ?? "0"}`
}

export const getCollaboratorLinkSheetInAdmin = <TCollaborator extends { id: string }>(
  collaborator?: TCollaborator | null
) => {
  return `${PATHS.ADMIN}${ADMIN_PATHS.COLLABORATORS}/${collaborator?.id ?? "0"}`
}
